<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70" />
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px;height:auto !important;"
          toggleable="lg" type="dark" variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Consignee Master</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form
              v-if="$sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh'">
              <b-button variant="outline-primary" @click="addEditCardFunc()" size="sm">Add</b-button>
              <!-- <b-button
                size="sm"
                class="ml-3"
                @click="getReportsAss('All_Consignee_Report')"
                variant="outline-info"
                >Export as Excel</b-button
              > -->
              <b-button :disabled="ExcelBtnName != 'Export as Excel' ? true : false" class="ml-3"
                @click="getReportsAss('All_Consignee_Report', 'Export as Excel')" size="sm" variant="outline-info">{{
                  ExcelBtnName }}
                <b-spinner v-if="ExcelBtnName != 'Export as Excel'" small label="Small Spinner"></b-spinner></b-button>

            </b-nav-form>

          </b-navbar-nav>

          <!-- <b-button
            v-if="
                  $sessionsStorage.get('designation') == 'Admin' &&
                  $sessionsStorage.get('nameUser') == 'Bhavneesh'
                "
            size="sm"
            class="ml-1"
            @click="getReports('All_Consignee_Report')"
            variant="outline-info"
          >Export</b-button>-->
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <!-- Add Update Form Input End-->
            <b-card class="gutr" v-if="addEditCard">
              <b-row class="align-items-end">
                <b-col md="12">
                  <h5>{{ ConsigneeMaster.agentName }} Consignee Details</h5>
                </b-col>
                <b-col md="3">
                  <label for="blType">Consignee Type</label>
                  <model-list-select :list="categoryTypeList" v-model="ConsigneeMaster.categoryType"
                    option-value="categoryTypeVal" option-text="categoryTypeTxt" isDisabled></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>
                    Consignee Name
                    <span class="error">*</span>
                  </label>
                  <b-form-input :formatter="capitalizeAll" id="agentName" name="agentName"
                    v-model="ConsigneeMaster.agentName" placeholder="Consignee Name"></b-form-input>
                  <span class="error" v-if="!ConsigneeMaster.agentName">
                    {{
                      errorList.agentName
                    }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>Contact No. <span class="error">*</span></label>
                  <b-form-input :formatter="capitalizeAll" id="contactNumber" name="contactNumber"
                    v-model="ConsigneeMaster.contactNumber" placeholder="Contact Number"></b-form-input>
                  <span class="error" v-if="!ConsigneeMaster.contactNumber">
                    {{
                      errorList.contactNumber
                    }}
                  </span>
                </b-col>

                <b-col md="3">
                  <label>Status :</label>
                  <md-switch :id="'approval' + ConsigneeMaster.isACActive" name="approval" class="md-primary"
                    :value="ConsigneeMaster.isACActive == 1 ? true : false" @change="activateconsigneeMaster()">
                    <h6>
                      <b-badge :variant="ConsigneeMaster.isACActive == 1 ? 'success' : 'danger'">{{
                        ConsigneeMaster.isACActive == 1 ? "Active" : "In-Active"
                      }}</b-badge>
                    </h6>
                  </md-switch>
                </b-col>
                <b-col md="3">
                  <label>Email <span class="error">*</span></label>
                  <b-form-input :formatter="capitalizeAll" id="emailId" name="emailId" v-model="ConsigneeMaster.emailId"
                    placeholder="Email"></b-form-input>
                  <span class="error" v-if="!ConsigneeMaster.emailId">
                    {{
                      errorList.emailId
                    }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>Company Name <span class="error">*</span></label>
                  <b-form-input :formatter="capitalizeAll" id="companyName" name="companyName"
                    v-model="ConsigneeMaster.companyName" placeholder="Company Name"></b-form-input>
                  <span class="error" v-if="!ConsigneeMaster.companyName">
                    {{
                      errorList.companyName
                    }}
                  </span>
                </b-col>
                <b-col md="6">
                  <label>Address <span class="error">*</span></label>
                  <b-form-textarea :formatter="capitalizeAll" id="address" name="address"
                    v-model="ConsigneeMaster.address"></b-form-textarea>
                  <span class="error" v-if="!ConsigneeMaster.address">
                    {{
                      errorList.address
                    }}
                  </span>
                </b-col>
                <b-col md="12">
                  <center>
                    <b-button style="margin-bottom: 0.3rem" variant="success" @click="addConsigneeMaster" class="mt-2"
                      id="addButtonLoader">
                      {{
                        consigneeMaster.agntColoaderId ? "Update" : "Save"
                      }}
                    </b-button>
                  </center>
                  <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                </b-col>
              </b-row>
            </b-card>
            <!-- Add Update Form Input End-->

            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row>
                <b-col md="8" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="filter"
                        placeholder="Type to Search Consignee Master and Code" ref="search" />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <model-list-select :list="StatusTypeList" v-model="Status" option-value="StatusTypeVal"
                    option-text="StatusTypeTxt" placeholder="Select Status" @input="getAllConsigneeMasterList"></model-list-select>
                </b-col>
                <b-col md="2">
                  <h5><small v-if="isLoading == false">{{ totalRows }} Entries</small></h5>
                </b-col>
              </b-row>
              <!-- Search Form Input End-->
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table show-empty stacked="md" :items="All_Consignee_List_data" :fields="fields"
                  :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" responsive
                  primary-key="stateId" class="position-relative">
                  <template slot="agntColoader" slot-scope="row0">
                    <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                  </template>
                  <template slot="categoryType" slot-scope="row1">
                    <span
                      @click="$sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh' ? viewEdit(row1.item) : ''"
                      class="showMoreData">{{ row1.item.categoryType }}</span>
                  </template>
                  <template slot="agentName" slot-scope="row11">
                    <span>{{ (row11.item.agentName != '') ? row11.item.agentName : '--' }}</span>
                  </template>
                  <template slot="contactNumber" slot-scope="row13">
                    <span>
                      Contact No. : {{ row13.item.contactNumber }}
                      <br>
                    </span>
                    <span>
                      Email : {{ row13.item.emailId }}
                      <br>
                    </span>
                  </template>

                  <template slot="bl_no" slot-scope="row14">
                    <span> {{ row14.item.bl_no }} </span>
                  </template>

                  <template slot="bl_date" slot-scope="row15">
                    <span> {{ row15.item.bl_date }} </span>
                  </template>

                  <template slot="creationTime" slot-scope="row16">
                    <span>
                      Created at: <br> {{ row16.item.creationTime }}
                      <br>
                    </span>
                    <span>
                      Created by: <br> {{ row16.item.createdBy }}
                      <br>
                    </span>
                  </template>

                  <template slot="updateTime" slot-scope="row17">
                    <span>
                      Updated at: <br> {{ row17.item.updateTime }}
                      <br>
                    </span>
                    <span>
                      Updated by: <br> {{ row17.item.UpdatedBy }}
                      <br>
                    </span>
                  </template>

                  <template slot="isACActive" slot-scope="row22">
                    <div v-if="adminToggle == 'Admin'" :id="'row' + row22.item.agntColoaderId">
                      <md-switch :id="'approval' + row22.item.agntColoaderId" name="approval" class="md-primary"
                        :value="row22.item.isACActive == 1 ? true : false" @change="activateConsigneeUser(row22.item)">
                        <h6>
                          <br>
                          <b-badge style="margin-left:-45px">{{ row22.item.isACActive == 1 ? 'Active' : 'In-Active'
                          }}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <div v-else :id="'row' + row22.item.agntColoaderId">
                      <h6>
                        <b-badge>{{ row22.item.isACActive == 1 ? 'Active' : 'In-Active' }}</b-badge>
                      </h6>
                    </div>
                  </template>

                  <template slot="action" slot-scope="row2">
                    <b-button variant="outline-primary" @click="editConsigneeMaster(row2.item)" id="addButtonLoader"
                      size="sm">Update</b-button>
                  </template>
                  <template slot="companyName" slot-scope="row14">
                    <span>
                      Company Name : {{ row14.item.companyName }}
                      <br>
                    </span>
                    <span>
                      Address : {{ row14.item.address }}
                      <br>
                    </span>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination limit="25" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                    class="my-0 pull-right" />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect, MultiSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import CommonService from "../../services/CommonService.js";
import CustomLoader from "../common/customLoader.vue";
import PaymentRequestService from "../../services/PaymentRequestService.js";
export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/consigneeMaster");
      if (globalPermissionStatus("Consignee Master") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("Consignee Master")
        );
      } else {
        this.$router.push({
          path: "/dashboard"
        });
      }
      this.getAllConsigneeMasterList();
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export as Excel",
      addEditCard: false,
      isLoading: false,
      fields: [
        {
          key: "agntColoader",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "agentName",
          label: "Consignee Name",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "companyName",
          label: "Company Details",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "contactNumber",
          label: "Contact Details",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "isACActive",
          label: "Status",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "bl_no",
          label: "bl_no",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "bl_date",
          label: "bl_date",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "creationTime",
          label: "creationTime",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "updateTime",
          label: "updateTime",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "action",
          label: "Actions",
          sortable: true,
          sortDirection: "desc"
        },
      ],
      Status: "2",
      StatusTypeList: [
        {
          StatusTypeVal: "0",
          StatusTypeTxt: "In-Active",
        },
        {
          StatusTypeVal: "1",
          StatusTypeTxt: "Active",
        },
        {
          StatusTypeVal: "2",
          StatusTypeTxt: "All",
        },
      ],
      currentPage: 1,
      perPage: 10,
      adminToggle: this.$sessionsStorage.get("designation"),
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      ConsigneeMaster: {
        agntColoaderId: "",
        categoryType: "Consignee",
        agentName: "",
        contactNumber: "",
        emailId: "",
        companyName: "",
        address: "",
        isACActive: true,
        TypeofAdd: "Consignee Master Add"
      },
      ConsigneeMasterError: [
        "Please Enter Consignee Name",
        "Please Enter Contact No.",
        "Please Enter Email",
        "Please Enter Company Name",
        "Please Enter Address"
      ],
      errorList: {
        agentName: "",
        contactNumber: "",
        emailId: "",
        companyName: "",
        address: ""
      },
      All_Charges_List_data: [],
      categoryTypeList: [
        {
          categoryTypeVal: "Consignee",
          categoryTypeTxt: "Consignee"
        }
      ],
      validate: true
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    }
  },
  mounted() { },

  beforeDestroy() { },

  destroyed() { },

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    MultiSelect
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {


    activateconsigneeMaster() {
      if (this.consigneeMaster.isACActive == 1 || this.consigneeMaster.isACActive == true) {
        this.consigneeMaster.isACActive = false;
      } else if (
        this.consigneeMaster.isACActive == 0 ||
        this.consigneeMaster.isACActive == false
      ) {
        this.consigneeMaster.isACActive = true;
      }
    },

    validateRefuelStation() {
      let validate_new = true;

      if (this.consigneeMaster.categoryType == "") {
        $("#categoryType").focus();
        this.categoryTypeError = "Select Category";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    async activateConsigneeUser(item) {
      if (!item) return;
      const previousStatus = Number(item.isACActive) === 1 ? 1 : 0;
      const desiredStatus = previousStatus === 1 ? 0 : 1;
      const agntColoaderId = Number(item.agntColoaderId);

      if (!agntColoaderId || agntColoaderId <= 0) {
        this.alert.content = "Invalid Consignee ID. Please provide a valid agntColoaderId.";
        this.$refs["addPop"].open();
        item.isACActive = previousStatus;
        return;
      }

      item.isACActive = desiredStatus;

      try {
        const payload = {
          agntColoaderId,
          isActive: desiredStatus,
          categoryType: item.categoryType || "Consignee",
      };
        const response = await PaymentRequestService.deleteConsignee(payload);
        const { data, status } = response || {};
        const success = status === 200 && data && data.status !== false;
        if (!success) {
          throw new Error(
            (data && (data.message || data.msg)) || "Failed to update consignee status."
          );
        }
        if (data.message || data.msg) {
          this.alert.content = data.message || data.msg;
          this.$refs["addPop"].open();
        }
        this.getAllConsigneeMasterList();
      } catch (error) {
        console.error("activateConsigneeUser error", error);
        item.isACActive = previousStatus;
        this.alert.content =
          (error && error.message) || "An error occurred while updating the status.";
        this.$refs["addPop"].open();
      }
    },


    validateConsigneeMaster() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (
          this.ConsigneeMaster[x] == "" ||
          this.ConsigneeMaster[x] == undefined ||
          this.ConsigneeMaster[x] == null
        ) {
          console.log("this.ConsigneeMaster[x]=>", this.ConsigneeMaster[x], x);
          console.log("this.ConsigneeMaster[x]=>", this.ConsigneeMaster);
          this.errorList[x] = this.ConsigneeMasterError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },
    addConsigneeMaster() {
      this.validateConsigneeMaster();
      this.ConsigneeMaster.TypeofAdd = "Consignee Master Add";
      if (this.validate == false) return false;
      this.isLoading = true;

      let payload = {
        itemCode: "add_Consignee_Details",
        ConsigneeMaster: this.ConsigneeMaster
      };
      payload = JSON.stringify(payload);
      if (this.validate != false) {
        CommonService.getAllCommonMaster(payload)
          .then(response => {
            const { data, status, statusText } = response;
            if (data.agntColoaderId != "" && data.agntColoaderId != undefined) {
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.addEditCardFunc();
              this.getAllConsigneeMasterList();
            } else {
              this.alert.content = data.MSG;
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
          })
          .catch(error => {
            console.log("Catch on Proforma Error: ", error);
          });
      }
    },
    getReportsAss(id, btnName) {
      let excelIdGivin = "";
      if (id == "All_Consignee_Report") {
        excelIdGivin = "All_Consignee_Report";
      }
      let payload = {
        excelId: excelIdGivin,
        assignmentNo: "Consignee",
        Status: this.Status
          ? this.Status
          : "",
      };
      this.ExcelBtnName = "Downloading Please Wait...";
      this.$store.dispatch(
        "common/setAllPendingReverseTallyExcel",
        JSON.stringify(payload)
      );
      let ExcelName = "";
      this.ExcelBtnName = btnName;
      if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
        ExcelName = this.$store.getters[
          "common/getAllPendingReverseTallyExcel"
        ];
      }
    },
    clearErrVal() {
      this.consigneeMaster = {
        categoryType: "Consignee",
        agentName: "",
        coLoaderName: "",
        contactNumber: "",
        emailId: "",
        companyName: "",
        address: "",
        isACActive: true,
        TypeofAdd: "Consignee Master Add"
      };
    },
    getAllConsigneeMasterList() {
      this.isLoading = true;
      let payload = {
        itemCode: "All_Consignee_List",
        Filter: this.Filter,
        Status: this.Status
          ? this.Status
          : "",
      };
      // JSON.stringify();
      // await
      CommonService.getAllCommonMaster(payload)
        .then(response => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.All_Consignee_List_data = data.All_Consignee_List_data;
            this.totalRows = data.All_Consignee_List_data.length;
            console.log(" All_Consignee_List response=>", data);
          } else {
            this.All_Consignee_List_data = [];
          }
          this.isLoading = false;
        })
        .catch(error => {
          console.log("Catch on All_Consignee_List Error: ", error);
        });
    },

    editConsigneeMaster(item) {
      console.log(item);
      this.clearErrVal();
      this.addEditCard = true;
      item.TypeofAdd = "Consignee Master Add";
      this.ConsigneeMaster = item;
      this.setFocus();
    },
    addEditCardFunc() {
      this.clearErrVal();
      this.addEditCard = !this.addEditCard;
    },
    setFocus: function () {
      // Note, you need to add a ref="search" attribute to your input.
      this.$refs.search.focus();
    },
    previousSalesView() {
      window.history.go(-1);
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllConsigneeMasterList("0", "0", "1", "1");
      }, 1000);
    },
    filterClear() {
      this.filter = "";
      this.getAllConsigneeMasterList("0", "0", "1", "1");
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    JqueryFun() {
      return $(function () {
        return $("#portLocationNew").DataTable();
      });
    },


  }
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}

.mrgtop-2per {
  margin-top: 1%;
}

.mrgtop-5px {
  margin-top: 0px;
}

.center {
  text-align: center;
}

.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}

.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// consigneeMaster.vue?b0edd002